/** Quién ha entrado (lo dice el servidor; aquí solo se recuerda para la interfaz, nunca para dar permisos). */
import type { Me } from './api-client.js';

let me: Me | null = null;
export const setCurrentUser = (m: Me | null) => { me = m; };
export const currentUser = () => me;
/** Muestra la gestión de usuarios. Quien decide es el servidor: sin ser administrador, la API responde 403. */
export const isAdmin = () => me?.role === 'admin';
